import './App.css';
import ToDoList from './ToDoList'
import {useState} from 'react';

function App() {

  const [item,setItem] = useState('');
  const [items,setItems] = useState([]);

  const addItem = ()=>{

      if(item==="")
      {
        alert("Invalid Item");
        return;
      }
      setItems( (oldItems) => { return [...oldItems,item];});
      setItem('');
      document.querySelector(".itemInput").value = "";
  }
  const deleteItem = (index)=>{
    setItems(items.filter( (item,i)=> i!==index));
  }

  return (
    <div className="App">
      <div className="container">
        <h1>ToDo App</h1>
        <input className="itemInput" 
              type="text" 
              placeholder="Add Item to List" 
              onChange={(event)=>{setItem(event.target.value)}}/>
              
        <button className="btnAdd" onClick={addItem}>+</button>
        <ToDoList list={items} delete={deleteItem}/>
      </div>
    </div>
  );
}

export default App;
